
  import {Component, Vue} from "vue-property-decorator";
  import breadcrumb from "@/components/common/breadcrumb.vue";
  import {
    getConfig,
    updatePixel,
    getMyAccountList,
    verifyAccountStatus,
    stopAccount,
    deleteAccount,
    getTempExcel,
    uploadAccountPage
  } from '@/services/api'
  import store from "@/store";
  import {AccountReq, Account} from "@/model/Account";
  import {AxiosResponse} from "axios";
  import Resp, {DownloadRes} from "@/model/Resp";


  @Component({
    components: {'zf-breadcrumb': breadcrumb},
  })
  export default class AccountList extends Vue {
    // 控制列表高度
    public tableHeight = window.innerHeight - 180;
    // 地区列表
    public areaList: {code: string, name: string}[] = [];
    // 状态列表
    public accountPageStatusList: {code: string, name: string}[] = [];
    // 上传表单
    public formData: AccountReq = {
      pageNum: 1,
      pageSize: 20
    }
    // 列表总数
    public totalNum = 0
    // 列表数据
    public tableData: Account[] = []
    // excel下载截流控制
    public tempCtrl = true;

    // 批量导出
    public downloadResVisible = false;
    public downloadRes: DownloadRes = {};


    /**
     * 初始化方法
     */
    async created(): Promise<void> {
      window.onresize = () => {
        try {
          this.tableHeight = window.innerHeight - 180;
        } catch (e) {}
      }
      await this.getMyAccountList();
      this.getConfig();
    }

    /**
     * 获取item列表
     */
    async getMyAccountList(): Promise<void> {
      await getMyAccountList(this.formData, true).then(res => {
        if (res.data && res.data.code === 200) {
          this.tableData = res.data.data.list || [];
          this.totalNum =  res.data.data.total || 0;
        }
      }).catch(() => {})
    }

    /**
     * 获取字典信息
     */
    getConfig(): void {
      if (!this.$store.state.region || this.$store.state.region.length === 0) {
        getConfig({type: 'region'}).then(res => {
          if (res.data && res.data.status === 'OK') {
            this.areaList = res.data.result || [];
            store.commit('SET_REGION', this.areaList);
          }
        })
      } else {
        this.areaList = this.$store.state.region;
      }

      if (!this.$store.state.accountPageStatusList || this.$store.state.accountPageStatusList.length === 0) {
        getConfig({type: 'accountPageStatus'}).then(res => {
          if (res.data && res.data.status === 'OK') {
            this.accountPageStatusList = res.data.result || [];
            store.commit('SET_ACCOUNT_PAGE_STATUS', this.accountPageStatusList);
          }
        })
      } else {
        this.accountPageStatusList = this.$store.state.accountPageStatusList;
      }
    }

    /**
     * 查询
     */
    search(): void {
      this.formData.pageNum = 1;
      this.getMyAccountList();
    }

    /**
     * 分页大小变化
     * @param val
     */
    handleSizeChange(val: number): void {
      this.formData.pageSize = val;
      this.formData.pageNum = 1;
      this.getMyAccountList();
    }

    /**
     * 当前页面变化
     * @param val
     */
    handleCurrentChange(val: number): void {
      this.formData.pageNum = val;
      this.getMyAccountList();
    }

    /**
     * 验证账户
     */
    verifyAccountStatus(accountId: string, pageId: string): void {
      verifyAccountStatus({accountId, pageId}, true).then(res => {
        this.handleRes(res);
      }).catch(() => {})
    }

    /**
     * 停用账户
     */
    stopAccount(accountId: string, pageId: string): void {
      stopAccount({accountId, pageId}, true).then(res => {
        this.handleRes(res);
      }).catch(() => {})
    }

    /**
     * 删除账户
     */
    deleteAccount(accountId: string, pageId: string): void {
      this.$confirm(`确认删除该记录吗？`).then(() => {
        deleteAccount({accountId, pageId}, true).then(res => {
          this.handleRes(res);
        }).catch(() => {})
      })
    }

    handleRes(res: AxiosResponse<Resp<any>>){
      if (res.data && res.data.code === 200){
        this.$message({
          duration: 8000,
          showClose: true,
          message: res.data.message || '操作成功！',
          type: 'success'
        });
        this.getMyAccountList();
      } else {
        this.$message({
          duration: 8000,
          showClose: true,
          message: res.data.message || '操作失败，请检查网络后重试！',
          type: 'warning'
        });
      }
    }

    /**
     * excel模板下载
     */
    async getTempExcel(): Promise<void> {
      if (this.tempCtrl) {
        this.tempCtrl = false;
        try {
          await getTempExcel(this.formData).then((res: any) => {
            this.handleExcelRes(res);
          })
        } catch (e) {}
        this.tempCtrl = true;
      }
    }
    handleExcelRes(res: any) {
      const blob = new Blob(
        [res.data], {type: 'application/vnd.ms-excel; chartset=utf-8'})
      const aEle = document.createElement('a');     // 创建a标签
      const href = window.URL.createObjectURL(blob);       // 创建下载的链接
      aEle.href = href;
      aEle.download = decodeURI(res.headers['content-disposition'].replace('attachment;filename=', ''));  // 下载后文件名
      document.body.appendChild(aEle);
      aEle.click();     // 点击下载
      document.body.removeChild(aEle); // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    }

    /**
     * excel上传
     */
    uploadExcel(ref: string) {
      const upload:any = this.$refs[ref];
      upload.click()
    }
    async handleUploadChange(i:any) {
      try{
        if (i.target?.files?.length > 0) {
          let params = new FormData()
          params.append('file', i.target.files[0]);
          await uploadAccountPage(params).then(res => {
            if (res.data && res.data.code === 200) {
              this.downloadResVisible = true;
              this.downloadRes = res.data.data;
              this.getMyAccountList();
            } else {
              this.$message({
                duration: 8000,
                showClose: true,
                message: res.data.message || '操作失败，请检查网络后重试！',
                type: 'warning'
              });
            }          })
        }
        i.target.value = '';
      } catch (e) {
        console.log(e)
      }
    }

    closeDownloadRes() {
      this.downloadResVisible = false;
    }

  }

